import React, { useContext, useState } from "react";
import { Title, IconButtonDatatable } from "App/Component/ui";
import { QuestionIcon } from "App/Assets";
import { KunjunganRawatJalanCtx } from "../context/context";
import { useFormRawatJalan, useReloadTable } from "./hooks";

const ModalWaktuAntrian = React.lazy(() => import("./ModalWaktuAntrian"));
const KunjunganRawatJalanTable = React.lazy(() =>
  import("./KunjunganRawatJalanTable")
);
const VerticalTabsFaq = React.lazy(() => import("./Faq/Tabs"));
const FormKunjunganRawatJalan = React.lazy(() =>
  import("./FormKunjunganRawatJalan")
);

export default function KunjunganRawatJalanWrapper() {
  const { state } = useContext(KunjunganRawatJalanCtx);

  const rows = state.rawat_jalan.list;
  const totalData = state.rawat_jalan.total_data;
  const {
    formData,
    setFormData,
    handleClickSelect,
    handleClickSelectBooking,
    registrationId,
    setRegistrationId,
    handleClickUpdate,
    handleClickReset,
    getAntreanJKN,
  } = useFormRawatJalan();

  const { setNewData } = useReloadTable();

  return (
    <>
      <FormKunjunganRawatJalanContainer
        formData={formData}
        setFormData={setFormData}
        handleClickSelect={handleClickSelect}
        handleClickSelectBooking={handleClickSelectBooking}
        registrationId={registrationId}
        setRegistrationId={setRegistrationId}
        handleClickReset={handleClickReset}
        setNewData={setNewData}
        getAntreanJKN={getAntreanJKN}
      />

      <KunjunganRawatJalanTable
        totalData={totalData}
        rows={rows}
        handleClickUpdate={handleClickUpdate}
      />

      <ul
        style={{
          fontSize: "11px",
          marginTop: "2rem",
          padding: "1rem",
        }}>
        <li>Gunakan F2 untuk memunculkan modal cari booking</li>
        <li>Gunakan F4 untuk memunculkan modal kunjungan baru </li>
        <li>Gunakan F6 untuk untuk reset form</li>
      </ul>
    </>
  );
}

const FormKunjunganRawatJalanContainer = ({
  formData,
  setFormData,
  handleClickSelect,
  handleClickSelectBooking,
  registrationId,
  setRegistrationId,
  handleClickReset,
  setNewData,
  getAntreanJKN,
}) => {
  const [showFaq, setShowFaq] = useState(false);
  const [showModalWaktuAntrian, setShowModalWaktuAntrian] = useState(false);

  const handleClickWaktuAntrian = () => [
    setShowModalWaktuAntrian(!showModalWaktuAntrian),
  ];

  return (
    <>
      {showFaq && <VerticalTabsFaq />}

      <ModalWaktuAntrian
        setShowModal={() => setShowModalWaktuAntrian(false)}
        showModal={showModalWaktuAntrian}
        registrasiId={registrationId}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Title title='Kunjungan Rawat Jalan' />
        <IconButtonDatatable
          onClick={() => setShowFaq(!showFaq)}
          style={{
            background: "none",
            border: "0",
            height: "30px",
          }}>
          <QuestionIcon width={"30px"} />
        </IconButtonDatatable>
      </div>

      <FormKunjunganRawatJalan
        formData={formData}
        setFormData={setFormData}
        setNewData={setNewData}
        setRegistrationId={setRegistrationId}
        registrationId={registrationId}
        handleClickSelectBooking={handleClickSelectBooking}
        handleClickSelectKunjBaru={handleClickSelect}
        handleClickWaktuAntrian={handleClickWaktuAntrian}
        handleClickReset={handleClickReset}
        getAntreanJKN={getAntreanJKN}
      />
    </>
  );
};
